import React from "react";
import { Avatar, Stack } from '@mui/material';

const BlogAuthorAvatar = ({ imageUrl, authorName }) => {
    return (
        <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
        >
            <Avatar
                src={imageUrl}
                sx={{ width: 32, height: 32 }}
            />
            <div>
                {authorName}
            </div>
        </Stack>
    )
}

export default BlogAuthorAvatar;